import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { Observable } from 'rxjs';
import { debounceTime, filter, map, startWith } from 'rxjs/operators';

@Component({
	selector: 'app-autocomplete',
	templateUrl: './autocomplete.component.html',
	styleUrls: ['./autocomplete.component.scss']
})
export class AutocompleteComponent implements OnInit, OnChanges {
	@Input() public data: any;
	public filteredOptions: Observable<any[string]>;
	public form: UntypedFormGroup;
	@Input() public formSubmitted: boolean;
	@Input() public initialValue: any;
	@Input() public label: string;
	@Input() public minLength: number;
	@Input() public placeholder: string;
	@Output() public processSelected: EventEmitter<any> = new EventEmitter<any>();
	@Input() public required: boolean;
	@Input() public requiredTextLength = 0;
	@Input() public warnReferenceMask = false;
	@Input() public maxLength: number;
	@Input() public restrictToOptions = false;

	constructor(private _formBuilder: UntypedFormBuilder) {
		this.form = this._formBuilder.group({
			search: ['', []],
		});
	}

	ngOnChanges(changes: SimpleChanges): void {
		this.form?.get('search')?.clearValidators();
		if (changes?.initialValue) {
			this.form?.get('search')?.setValue(this.initialValue);
		}
		if (this.required) {
			this.form?.get('search')?.addValidators(Validators.required);
		}
		if (this.formSubmitted) {
			this.form?.get('search')?.markAsTouched();
		}

		if(this.maxLength) {
			this.form?.get('search')?.addValidators(Validators.maxLength(this.maxLength));
		}

		this.form?.get('search')?.updateValueAndValidity();

		this.filteredOptions = this.form.get('search').valueChanges.pipe(
			startWith(''),
			filter(x => typeof x === 'string'),
			map((value) => this._filter(value))
		);
	}

	ngOnInit(): void {
		this.filteredOptions = this.form.get('search').valueChanges.pipe(
			startWith(''),
			filter(x => typeof x === 'string'),
			map((value) => this._filter(value))
		);
	}

	select(selectedOption): void {
		this.processSelected.emit(selectedOption);
	}

	onBlur(): void {
		if (!this.restrictToOptions) return;
		
		const currentValue = this.form.get('search')?.value;
		if (currentValue && !this.isValidOption(currentValue)) {
			// Clear invalid value and emit empty selection
			this.form.get('search')?.setValue('');
			this.processSelected.emit('');
		}
	}

	private isValidOption(value: string): boolean {
		if (!value || !this.data) return false;
		return this.data.some(item => item.value === value);
	}

	private _filter(value: string): any[string] {
		if (!this.data) return [];
		const filterValue = value.toLowerCase();
		return this.data.map(({value}) => (value)).filter((option) => option.toLowerCase().includes(filterValue));
	}

}
